import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { red, green, grey } from '@mui/material/colors';

let theme = createTheme({
    palette: {
        primary: {
            main: red[700], 
        },
        seconday: {
            main: '#f3f3f3',
        },
        backgroundPainel: {
            main: grey[100],
        },
    },
    // typography: {
    //     fontFamily: ['Inter', '-apple-system', 'Roboto', '"Segoe UI"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    //     fontSize: 14,
    // },
    typography: {
        fontFamily: ['Inter', '-apple-system', 'Roboto', '"Segoe UI"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
        fontSize: 14,
        h1: {
            fontSize: '2.5rem',
            fontWeight: 700,
            color: '#ff5722', // Laranja vibrante
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 600,
            color: '#1976d2', // Azul padrão do MUI
        },
        h6: {
            fontSize: '1.4rem',
        },
        body2: {
            fontSize: '1.3rem',
            fontWeight: 400,
            lineHeight: 1.5,
            color: '#424242', // Cinza escuro
        },
        // body1: {
        //     fontSize: '1rem',
        //     fontWeight: 400,
        //     lineHeight: 1.5,
        //     color: '#424242', // Cinza escuro
        // },
        button: {
            fontSize: '1rem',
            fontWeight: 500,
            textTransform: 'none', // Evitar o texto em maiúsculo padrão
        },
    },
});
theme = responsiveFontSizes(theme);

export default theme;
